import React, { PropsWithChildren } from 'react';

class ErrorBoundary extends React.Component<PropsWithChildren> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error(error);
    console.error(errorInfo);
    console.error('stack:');
    console.error(error.stack);
  }

  render() {
    if (this.state.hasError) {
      return null;
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
